export const FETCH_ONBOARDING_QUEUE = "ONBOARDING_BUILDER/FETCH_QUEUE";
export const FETCH_ONBOARDING_QUEUE_SUCCESS =
  "ONBOARDING_BUILDER/FETCH_QUEUE_SUCCESS";
export const FETCH_ONBOARDING_QUEUE_FAILURE =
  "ONBOARDING_BUILDER/FETCH_QUEUE_FAILURE";

export const DISMISS_QUEUE_ITEM = "ONBOARDING_BUILDER/DISMISS_QUEUE_ITEM";
export const DISMISS_QUEUE_ITEM_SUCCESS =
  "ONBOARDING_BUILDER/DISMISS_QUEUE_ITEM_SUCCESS";
export const DISMISS_QUEUE_ITEM_FAILURE =
  "ONBOARDING_BUILDER/DISMISS_QUEUE_ITEM_FAILURE";

export const RESTORE_QUEUE_ITEM = "ONBOARDING_BUILDER/RESTORE_QUEUE_ITEM";
export const RESTORE_QUEUE_ITEM_SUCCESS =
  "ONBOARDING_BUILDER/RESTORE_QUEUE_ITEM_SUCCESS";
export const RESTORE_QUEUE_ITEM_FAILURE =
  "ONBOARDING_BUILDER/RESTORE_QUEUE_ITEM_FAILURE";

export const FETCH_TEMPLATE_GOVERNANCE =
  "ONBOARDING_BUILDER/FETCH_TEMPLATE_GOVERNANCE";
export const FETCH_TEMPLATE_GOVERNANCE_SUCCESS =
  "ONBOARDING_BUILDER/FETCH_TEMPLATE_GOVERNANCE_SUCCESS";
export const FETCH_TEMPLATE_GOVERNANCE_FAILURE =
  "ONBOARDING_BUILDER/FETCH_TEMPLATE_GOVERNANCE_FAILURE";

export const SET_CURRENT_TEMPLATE = "ONBOARDING_BUILDER/SET_CURRENT_TEMPLATE";
export const RESET_BUILDER = "ONBOARDING_BUILDER/RESET";
